module.exports = __webpack_public_path__ + "img/sez-bg2.a5b39ea9.png";